export default "__VITE_ASSET__DCF5pUKE__"